/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { AnyAction } from 'redux';
import { ReduxStateLoadable } from '@reducers/types';
import { UtrvDataState } from '../types/universalTrackerValue';

type State = ReduxStateLoadable<UtrvDataState[], UtrvDataState[]>
  & { initiativeId?: null | string, surveyId?: null | string }

const getDefaultState = (): State => ({
  data: [],
  initiativeId: null,
  surveyId: null,
  loaded: false,
  errored: false,
  errorMessage: ''
});

const universalTrackerValues = (
  state = getDefaultState(),
  action: AnyAction,
): State => {
  switch (action.type) {
    case actionTypes.LOADING_UNIVERSALTRACKERVALUES:
      return {
        ...state,
        initiativeId: action.initiativeId,
        surveyId: action.surveyId,
        data: [],
        loaded: false,
        errored: false,
        lastUpdated: Date.now()
      }
    case actionTypes.ERROR_UNIVERSALTRACKERVALUES:
      return {
        ...state,
        data: [],
        loaded: false,
        errored: true,
        lastUpdated: Date.now(),
        errorMessage: action.errorMessage
      }
    case actionTypes.NO_DATA_UNIVERSALTRACKERVALUES:
      return {
        ...state,
        initiativeId: action.initiativeId,
        surveyId: action.surveyId,
        data: [],
        loaded: false,
        errored: false,
        lastUpdated: Date.now()
      }
    case actionTypes.LOADED_UNIVERSALTRACKERVALUES:
      return {
        ...state,
        initiativeId: action.initiativeId,
        surveyId: action.surveyId,
        data: action.data,
        loaded: true,
        errored: false,
        lastUpdated: Date.now()
      }
    default:
      return state;
  }
}

export default universalTrackerValues;
